import React, {useRef, useState} from 'react';
import * as R from 'ramda';
import {RegexFields} from '../../constants/utils/regexFields';
import { ReactMultiEmail } from "react-multi-email";
import {shareDocuments} from '../../actions/facilita-api';
import "react-multi-email/style.css";
import { useDispatch } from 'react-redux';
import * as loadings from '../../constants/loadings/facilita/deathDeclaration';
import {ToasterConfigurations} from '../../constants/toasterText/configurations';
import $ from 'jquery';
import { toast } from 'react-toastify';

export const ModalConfirmation = ({fileNames, userId, userRepresentativeId, isLoading }) => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const [emailAddresses, setEmailAddresses] = useState([]);

	return (
		<div className="modal fade px-0" id="confirmation" aria-labelledby="confirmationLabel" aria-hidden="true">
			<div className="modal-dialog px-2 container-base text-center">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-success rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Share docs</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-success text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="confirmationLabel">Confirmation document</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						<p className="h5 lh-copy mb-3 o-60">Veuillez remplir le formulaire ci-dessous en conséquence pour confirmer que vous souhaitez remplacer le document existant.</p>
						<form className="flex-row gap-2 justify-content-center" noValidate ref={formRef}>
							<div className="custom-control custom-radio">
								<input type="radio" id="customRadio1" name="customRadio" className="custom-control-input" />
								<label className="custom-control-label border-gray o-100 mr-1 form-check-label" htmlFor="customRadio1">Replace document</label>
							</div>
							<div className="custom-control custom-radio">
								<input type="radio" id="customRadio2" name="customRadio" className="custom-control-input" />
								<label className="custom-control-label border-gray o-100 mr-1 form-check-label" htmlFor="customRadio2">Merge documents</label>
							</div>
						</form>
					</div>
					<div className="modal-footer justify-content-center gap-1 pt-0">
						<button type="button" className="btn btn-light" data-dismiss="modal">Annuler</button>
						<button type="button" className="btn btn-success loading-btn" data-toggle="modal" data-target="#telecharger"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Continuer</button>
					</div>
				</div>
			</div>
		</div>
	)
}